import {Routes} from '@angular/router';
import {LoginScreenComponent} from "./login-screen/login-screen.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {InAppMessagesHubComponent} from "./in-app-messages-hub/in-app-messages-hub.component";
import {AppStatysticsComponent} from "./app-statystics/app-statystics.component";
import {InAppMessagesComponent} from "./in-app-messages/in-app-messages.component";
import {SiteMessagesComponent} from "./site-messages/site-messages.component";
import {AppThemeComponent} from "./app-theme/app-theme.component";
import {SiteCategoriesComponent} from "./site-categories/site-categories.component";
import {CategoryPricesComponent} from "./category-prices/category-prices.component";
import {VersionHistoryComponent} from "./version-history/version-history.component";
import {HubRemoteConfigComponent} from "./hub-remote-config/hub-remote-config.component";
import {HubStatisticsComponent} from "./hub-statistics/hub-statistics.component";
import {PageComponent} from "./page/page.component";
import {AppRatingComponent} from "./app-rating/app-rating.component";
import {HealthCheckComponent} from "./health-check/health-check.component";
import {UsersAndPermissionsPage} from "./users-and-permissions-page/users-and-permissions-page.component";
import {NoAccessComponent} from "./no-access/no-access.component";
import {authGuard} from "./services/auth.guard";
import {NpsComponent} from "./nps/nps.component";
import {ReviewsComponent} from "./reviews/reviews.component";
import {MigrateSitesComponent} from "./migrate-sites/migrate-sites.component";
import {RfidPriceComponent} from "./rfid-price/rfid-price.component";

export const routes: Routes = [
  {
    path: 'main', component: PageComponent, children: [
      //app routes
      {path: 'appStatistics', component: AppStatysticsComponent, canActivate: [authGuard], data: {access: 'Statistics'}},
      {path: 'usersAndPermissions', component: UsersAndPermissionsPage, canActivate: [authGuard], data: {access: 'Users and Permissions'}},
      {path: 'healthCheck', component: HealthCheckComponent, canActivate: [authGuard], data: {access: 'Health Check'}},
      {path: 'nps', component: NpsComponent, canActivate: [authGuard], data: {access: 'Nps'}},
      {path: 'rattings', component: ReviewsComponent, canActivate: [authGuard], data: {access: 'Nps'}},
      {path: 'inAppMessage', component: InAppMessagesComponent, canActivate: [authGuard], data: {access: 'In-app message'}},
      {path: 'siteMessage', component: SiteMessagesComponent, canActivate: [authGuard], data: {access: 'Site message'}},
      {path: 'migrateSites', component: MigrateSitesComponent, canActivate: [authGuard], data: {access: 'Migrate Sites'}},
      {path: 'appRemoteConfig', component: AppThemeComponent},
      {path: 'siteCategories', component: SiteCategoriesComponent, canActivate: [authGuard], data: {access: 'Site Categories'}},
      {path: 'versionHistory', component: VersionHistoryComponent, canActivate: [authGuard], data: {access: 'Version history'}},
      {path: 'chargingPrices', component: CategoryPricesComponent, canActivate: [authGuard], data: {access: 'Charging prices'}},
      {path: 'rfidPrice', component: RfidPriceComponent, canActivate: [authGuard], data: {access: 'RFID price'}},
      {path: 'appRating', component: AppRatingComponent, canActivate: [authGuard], data: {access: 'App rating'}},
      {path: 'noAccess', component: NoAccessComponent},

      // hub routes
      {path: 'inHubMessage', component: InAppMessagesHubComponent},
      {path: 'hubRemoteConfig', component: HubRemoteConfigComponent},
      {path: 'hubStatistics', component: HubStatisticsComponent},
    ]
  },


  {path: 'rfidPrice', redirectTo: '/main/rfidPrice', pathMatch: 'full'},
  {path: '', component: LoginScreenComponent},
  {path: '**', component: PageNotFoundComponent},

];
